/**
 * Retorna la URL base para las APIs del CRM FastAPI y Telethon.
 * En producción (cuando el hostname no es localhost ni 127.0.0.1),
 * SIEMPRE utiliza la ruta relativa '/api/v1' para que las peticiones vayan
 * directamente al proxy del servidor y no fallen en el navegador del usuario.
 */
export function getCrmBackendUrl(): string {
  if (typeof window !== 'undefined' && window.location?.hostname) {
    const { hostname } = window.location;
    if (hostname !== 'localhost' && hostname !== '127.0.0.1') {
      return '/api/v1';
    }
  }

  return import.meta.env.VITE_BACKEND_API_URL || '/api/v1';
}

export const CRM_BACKEND_URL = getCrmBackendUrl();
